import styled from "styled-components";

export const Toggle = styled.div`
  width: 250px;
  height: 45px;
  padding: 10px 0px 0px 0px;
  gap: 10px;
  border-radius: 5px 0px 0px 0px;
  background-color: #f8f8f8;
  font-family: "DM Sans";
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
`;

export const CategoryLabel = styled.p`
  font-family: "Nunito";
  font-size: 18px;
  font-weight: 300;
  line-height: 22px;
  text-align: left;
  width: 100%;
  padding-top: 0px;
  margin-bottom: 10px;
`;

export const CategoryTitle = styled.h5`
  font-family: "Nunito";
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
`;

export const CategoryText = styled.p`
  font-family: "Nunito";
  font-size: 14px;
  font-weight: 300;
`;

export const TextError = styled.p`
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 300;
  color: red;
`;
